import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";
import Header from "../../header/Header";

const CompleteInformation = () => {
    return (
        <div className="complete-information-wrapper">
            <div className="header">
                <Header/>
            </div>
            <div className="information-content">
                <div className="container">
                    <div className="title">
                        <div className="title-box just-text title-box-blue">
                            <div className="title-bg">
                                <h2 className="text">
                                    تکمیل اطلاعات حساب کاربری
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="inputs-information">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="name-input position-relative">
                                    <input type="text" placeholder="نام"
                                           className="form-control input-normal xmt-6 check-button-info xmt-lg-8"/>
                                    <div className="error-text">متن راهنمای خطا</div>
                                    <div className="error-icon position-absolute"><IconName name="alert"
                                                                                            className="icon"/></div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="name-input position-relative">
                                    <input type="text" placeholder="نام خانوادگی"
                                           className="form-control input-normal xmt-6 check-button-info xmt-lg-8"/>
                                    <div className="error-text">متن راهنمای خطا</div>
                                    <div className="error-icon position-absolute"><IconName name="alert"
                                                                                            className="icon"/></div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="name-input position-relative">
                                    <input type="text" placeholder="کد ملی"
                                           className="form-control input-normal check-button-info xmt-6"/>
                                    <div className="error-text">متن راهنمای خطا</div>
                                    <div className="error-icon position-absolute"><IconName name="alert"
                                                                                            className="icon"/></div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="name-input position-relative">
                                    <div
                                        className="persian-number disabled-input input-normal xmt-6">09904456321
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="user-address xmt-8">
                        <div className="title">
                            <div className="title-box just-text title-box-blue">
                                <div className="title-bg">
                                    <h2 className="text">
                                        تکمیل اطلاعات حساب کاربری
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="name-input select position-relative">
                                    <select
                                        className="form-select input-normal check-button-info xmt-12 xmt-lg-8"
                                        aria-label="Default select example">
                                        <option value="">استان</option>
                                        <option value="21">اصفهان</option>
                                        <option value="3">تهران</option>
                                        <option value="4">فارس</option>
                                    </select>
                                    <IconName name="expand_more" className="icon position-absolute more-icon"/>
                                    <div className="error-text">متن راهنمای خطا</div>
                                    <div className="error-icon position-absolute"><IconName name="alert"
                                                                                            className="icon"/></div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="name-input select position-relative">
                                    <select
                                        className="form-select input-normal check-button-info xmt-6 xmt-lg-8"
                                        aria-label="Default select example">
                                        <option value="">شهر</option>
                                        <option value="21">اصفهان</option>
                                        <option value="3">تهران</option>
                                        <option value="4">شیراز</option>
                                    </select>
                                    <IconName name="expand_more" className="icon position-absolute more-icon"/>
                                    <div className="error-text">متن راهنمای خطا</div>
                                    <div className="error-icon position-absolute"><IconName name="alert"
                                                                                            className="icon"/></div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="name-input position-relative">
                                    <input type="text" placeholder="نشانی"
                                           className="form-control d-none d-lg-block address input-normal xmt-6"/>
                                    <textarea placeholder="نشانی"
                                              className="form-control address d-block d-lg-none input-normal xmt-6"/>
                                    <div className="error-text">متن راهنمای خطا</div>
                                    <div className="error-icon position-absolute"><IconName name="alert"
                                                                                            className="icon"/></div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="name-input position-relative">
                                    <input type="text" placeholder="پلاک"
                                           className="form-control input-normal xmt-6 check-button-info"/>
                                    <div className="error-text">متن راهنمای خطا</div>
                                    <div className="error-icon position-absolute"><IconName name="alert"
                                                                                            className="icon"/></div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="name-input position-relative">
                                    <input type="number" placeholder="واحد"
                                           className="form-control input-normal xmt-6 check-button-info"/>
                                    <div className="error-text">متن راهنمای خطا</div>
                                    <div className="error-icon position-absolute"><IconName name="alert"
                                                                                            className="icon"/></div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="name-input position-relative">
                                    <input type="number" placeholder="کد پستی"
                                           className="form-control input-normal xmt-6 check-button-info"/>
                                    <div className="error-text">متن راهنمای خطا</div>
                                    <div className="error-icon position-absolute"><IconName name="alert"
                                                                                            className="icon"/></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="step-buy-cart-info position-fixed">
                <div className="container d-flex justify-content-between align-items-center">
                    <div className="prev-button">
                        <Link to="/cartPage" className="text">قبلی</Link>
                    </div>
                    <div className="step-buy">
                        <ul className="nav persian-number">
                            <li className="nav-item before">
                                <Link to="/cartPage">
                                    <div className="step"><span>1</span></div>
                                    <div
                                        className="text">سبد خرید
                                    </div>
                                </Link>
                            </li>
                            <li className="nav-item active">
                                <Link to="/infoUser">
                                    <div className="step"><span>2</span></div>
                                    <div
                                        className="text">تکمیل اطلاعات
                                    </div>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <a href="#">
                                    <div className="step"><span>3</span></div>
                                    <div
                                        className="text">شیوه‌ی ارسال
                                    </div>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#">
                                    <div className="step"><span>4</span></div>
                                    <div
                                        className="text">تایید نهایی
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="step-circle-buy d-flex d-lg-none">
                        <div className="nav-item">
                            <a href="#" className="step-buy active"><span className="step"></span></a>
                        </div>

                        <div className="nav-item">
                            <a href="#" className="step-buy"><span className="step"></span></a>
                        </div>
                        <div className="nav-item">
                            <a href="#" className="step-buy"><span className="step"></span></a>
                        </div>
                    </div>
                    <div className="button-next info-button d-none d-lg-flex">
                        <Link to="/productDelivery" id="next-button-info-user">
                            <span className="text">شیوه ارسال</span>
                            <IconName name="chevron_left" className="icon"/>
                        </Link>
                    </div>
                    <div className="button-next info-button d-flex d-lg-none">
                        <Link to="/productDelivery" id="next-button-info-user-responsive">
                            <span className="text">بعدی</span>
                            <IconName name="chevron_left" className="icon"/>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompleteInformation;
